import { combineReducers } from "redux";

// Front
import LayoutReducer from "slices/layouts/reducer";

// Authentication
import LoginReducer from "slices/auth/login/reducer";
import ProfileReducer from "slices/auth/profile/reducer";
import PermanentConnectionReducer from "slices/permanentConnection/reducer";
import PremiseAmalgmationReducer from "slices/premiseAmalgmation/reducer";
import TemporaryConnectionReducer from "slices/temporaryConnection/reducer";
import NameTransferConnectionReducer from "slices/nameTransferConnection/reducer";
import changeOfCategoryReducer from "slices/changeOfCategory/reducer";
import RemovalOfConnectionReducer from "slices/removalOfConnection/reducer";
import demandAlterationReducer from "slices/demandAlteration/reducer";
import PremiseRemovalReducer from "slices/premiseRemoval/reducer";
import shiftingOfServiceReducer from "slices/shiftingOfService/reducer";
import backupPowerReducer from "slices/BackupPower/reducer";
import NetMeteringConnectionReducer from "slices/netMeteringConnection/reducer";

import { api } from "./api";

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  Layout: LayoutReducer,
  Login: LoginReducer,
  Profile: ProfileReducer,
  PermanentConnection: PermanentConnectionReducer,
  PremiseAmalgmation: PremiseAmalgmationReducer,
  PremiseRemoval: PremiseRemovalReducer,
  temporaryConnection: TemporaryConnectionReducer,
  nameTransferConnection: NameTransferConnectionReducer,
  changeOfCategory: changeOfCategoryReducer,
  RemovalOfConnection: RemovalOfConnectionReducer,
  demandAlteration: demandAlterationReducer,
  shiftingOfService: shiftingOfServiceReducer,
  backupPower: backupPowerReducer,
  netMeteringConnection: NetMeteringConnectionReducer,
});

export default rootReducer;
